import { Component, Input } from '@angular/core';
import { RoleEnum } from 'src/app/enums/role-enum';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss']
})
export class PermissionComponent {

  @Input() notAllowedRoles: RoleEnum[] = [];

  constructor(
    public sharedService: SharedService
  ) { }

  viewContentInside() {
    let view = true;
    const userRole = this.sharedService.userRole;
    view = !(this.notAllowedRoles.includes(userRole!));
    return view;
  }
}
